<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none text-center" to="/">
      <div>
<!--        <img src="/images/icons/android-icon-48x48.png">-->
        Rayan API Dashboard </div>
    </CSidebarBrand>

<!--    <CRenderFunction flat :content-to-render="$options.nav"/>-->
    <CRenderFunction flat :content-to-render="menuList"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />


  </CSidebar>
</template>

<script>
import nav from './_nav'

export default {
  name: 'TheSidebar',
  nav,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  },

  data: function () {
    return {
      auth: {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token')
        }
      },

      menuList:[
        {
          _name: 'CSidebarNav',
          _children: [
            {
              _name: 'CSidebarNavItem',
              name: 'داشبورد',
              to: '/dashboard',
              icon: 'cil-speedometer',
              // badge: {
              //   color: 'primary',
              //   text: 'NEW'
              // }
            },
            // {
            //   _name: 'CSidebarNavTitle',
            //   _children: ['بازاریابی و فروش']
            // },
            // {
            //   _name: 'CSidebarNavItem',
            //   name: 'افزودن مشتری',
            //   to: '/contact/create',
            //   icon: 'cil-drop'
            // },
            // {
            //   _name: 'CSidebarNavItem',
            //     name: 'مدیریت اطلاعات تماس',
            //   to: '/contact/list',
            //   icon: 'cil-pencil'
            // },
            // {
            //   _name: 'CSidebarNavTitle',
            //   _children: [' عملیات']
            // },
            // {
            //   _name: 'CSidebarNavDropdown',
            //   name: 'اتوماسیون',
            //   route: '/base',
            //   icon: 'cil-puzzle',
            //   items: []
            //
            //
            //
            //
            //
            // },
            //
            // // {
            // //     _name: 'CSidebarNavDropdown',
            // //     name: 'مدیریت گردش ها',
            // //     route: '/base',
            // //     icon: 'cil-puzzle',
            // //     items: [
            // //
            // //
            // //         {
            // //             name: 'افزودن گردش',
            // //             to: '/base/forms'
            // //         },
            // //     ]
            // // },
            //
            // {
            //   _name: 'CSidebarNavDropdown',
            //   // name: 'تأمین‌، خرید و...',
            //   name: 'تأمین‌ و سفارش',
            //   route: '/base',
            //   icon: 'cil-puzzle',
            //   items: [
            //     // {
            //     //     _name: 'CSidebarNavItem',
            //     //     name: 'افزودن سرنخ/فرصت',
            //     //     to: '/contact/create',
            //     //     icon: 'cil-drop'
            //     // },
            //     {
            //       name: 'اطلاعات تماس',
            //       to: '/contact/'
            //     },
            //     {
            //       name: 'پیگیری سفارشات',
            //       to: '/order/'
            //     },
            //     // {
            //     //   name: 'هدایا و تخفیفات',
            //     //   to: '/'
            //     // },
            //
            //   ]
            // },
            // {
            //   _name: 'CSidebarNavDropdown',
            //   name: 'پروژه ها و کارها',
            //   route: '/base',
            //   icon: 'cil-cursor',
            //   items: [
            //     {
            //       name: 'لیست پروژه ها',
            //       to: '/project/list'
            //     },
            //     {
            //       name: 'میز کار (Boards)',
            //       to: '/boards'
            //     },
            //     {
            //       name: 'تابلو کاری (Wall)',
            //       to: '/wall'
            //     },
            //     // {
            //     //   name: 'تقویم کاری',
            //     //   to: '/'
            //     // },
            //     // {
            //     //   name: 'پروژ های من',
            //     //   to: '/'
            //     // }
            //
            //
            //     {
            //       // _name: 'CSidebarNavDropdown',
            //       name: ' زمانبندی اجرا (Sprints)',
            //       // route: '/Sprints',
            //       to: '/Sprints',
            //       // icon: 'cil-puzzle',
            //       items: [
            //         {
            //           name: 'Sprint های فعال',
            //           to: '/Sprints'
            //         },
            //         {
            //           name: 'مدیریت Sprint ها',
            //           to: '/sprint/list'
            //         }
            //
            //       ]
            //     },
            //
            //
            //   ]
            // },
            {
              _name: 'CSidebarNavDropdown',
              name: 'مالی و حسابداری',
              route: '/base',
              icon: 'cil-puzzle',
              items: [
                {
                  name: 'مدیریت فاکتور ها',
                  to: '/order/list'
                },
                // {
                //   name: 'کد های حسابدری',
                //   to: '/accountingCode/list'
                // },

                // {
                //   _name: 'CSidebarNavDropdown',
                //   name: 'سایر اسناد',
                //   route: '/base',
                //   icon: 'cil-puzzle',
                //   items: [
                //     {
                //       name: 'دریافتی ها (درآمد)',
                //       to: '/customerPayment/list'
                //     },
                //     {
                //       name: 'پرداختی ها (هزینه)',
                //       to: '/companyPayment/list'
                //     },
                //     {
                //       name: 'ورود و خروج انبار (بارنامه)',
                //       to: '/loading/list'
                //     }
                //
                //   ]
                // },

              ]
            },


            // {
            //   _name: 'CSidebarNavDropdown',
            //   name: 'خدمات و کالا ها',
            //   route: '/pages',
            //   icon: 'cil-star',
            //   items: [
            //
            //     {
            //       name: 'گروه/دسته کالا ها',
            //       to: '/productCategory/list'
            //     },
            //     {
            //       name: 'پارت کالا ها / موجودی',
            //       to: '/product/list'
            //     },
            //
            //
            //     {
            //       name: 'گروه/دسته خدمات',
            //       to: '/serviceCategory/list'
            //     },
            //     {
            //       name: 'آیتم های خدمات ',
            //       to: '/service/list'
            //     },
            //   ]
            // },




            {
              _name: 'CSidebarNavTitle',
              _children: ['گزارشات']
            },
            {
              _name: 'CSidebarNavDropdown',
              name: 'گزارشات کلی',
              route: '/base',
              icon: 'cil-puzzle',
              items: [

                // {
                //     name: 'گزارش فروش',
                //     to: '/'
                // },
                // {
                //     name: 'گزارش مشتریان',
                //     to: '/'
                // },
                //
                // {
                //     name: 'گزارش پرسنل',
                //     to: '/'
                // }
              ]
            },
            {
              _name: 'CSidebarNavDropdown',
              name: 'گزارشات پیشرفته',
              route: '/buttons',
              icon: 'cil-cursor',
              items: [
                // {
                //     name: 'گزارش درآمد و هزینه',
                //     to: '/'
                // },
                // {
                //     name: 'گزارش حساب ها',
                //     to: '/'
                // },
                // {
                //     name: 'پرداختی های مشتریان',
                //     to: '/'
                // },

              ]
            },




            {
              _name: 'CSidebarNavTitle',
              _children: ['اطلاعات سیستم']
            },
            // {
            //   _name: 'CSidebarNavDropdown',
            //   name: 'مدیریت پرسنل',
            //   route: '/pages',
            //   icon: 'cil-star',
            //   items: [
            //
            //     {
            //       name: 'لیست پرسنل',
            //       to: '/'
            //     },
            //     {
            //       name: 'دریافتی پرسنل',
            //       to: '/'
            //     }
            //   ]
            // },
            {
              _name: 'CSidebarNavDropdown',
              name: 'تنظیمات کاربری',
              route: '/user/list',
              icon: 'cil-star',
              items: [

                // {
                //   name: 'مدیریت کاربران',
                //   to: '/user/list'
                // },
                // {
                //   name: 'مدیریت نقش ها',
                //   to: '/'
                // }
              ]
            },

            // {
            //   _name: 'CSidebarNavDropdown',
            //   name: ' نوع موجودیت و فیلد ها',
            //   route: '/issue/types',
            //   icon: 'cil-star',
            //   items: [
            //
            //     {
            //       name: 'مدیریت فیلد ها',
            //       to: '/field/list'
            //     },
            //
            //     {
            //       name: 'Issue Types',
            //       to: '/issueType/list'
            //     },
            //     // {
            //     //   name: 'Contact Types',
            //     //   to: '/issue/types'
            //     // },
            //     // {
            //     //   name: 'Order Types',
            //     //   to: '/issue/types'
            //     // },
            //
            //   ]
            // },
            //
            // {
            //   _name: 'CSidebarNavDropdown',
            //   name: 'فرایند‌ها و گردش کار',
            //   route: '/',
            //   icon: 'cil-star',
            //   items: [
            //     {
            //       name: 'مدیریت فرایند‌ها',
            //       to: '/process/list'
            //     },
            //     {
            //       name: 'مدیریت گردش‌ها',
            //       to: '/flow/list'
            //     },
            //     // {
            //     //   name: 'مدیریت زمانبندی‌ها',
            //     //   to: '/condition/list'
            //     // },
            //
            //   ]
            // },
            // {
            //   _name: 'CSidebarNavItem',
            //   name: 'Download CoreUI',
            //   href: 'http://coreui.io/vue/',
            //   icon: { name: 'cil-cloud-download', class: 'text-white' },
            //   _class: 'bg-success text-white',
            //   target: '_blank'
            // },
            // {
            //   _name: 'CSidebarNavItem',
            //   name: 'Try CoreUI PRO',
            //   href: 'http://coreui.io/pro/vue/',
            //   icon: { name: 'cil-layers', class: 'text-white' },
            //   _class: 'bg-danger text-white',
            //   target: '_blank'
            // }
          ],



        }
      ],




      processes:[],

    }
  },





  mounted() {

    // let app = this
    // axios.get('/api/intro/processes', app.auth)
    //         .then(function (response) {
    //
    //           for (let value of response.data.data.data) {
    //             app.processes.push({
    //                 name: ' فرایند '+value.title,
    //                 to: '/processBoard/'+ value.id
    //               })
    //           }
    //           app.menuList[0]._children[2].items = app.processes
    //         })
    //         .catch(function (e) {
    //           console.log(e.response);
    //         });




    // this.setProcesses()

  },

  method:{

    // setProcesses(){
    //   var app = this;
    //   axios.get('/api/intro/processes', app.auth)
    //           .then(function (response) {
    //             app.processes = response.data.data.data
    //
    //           })
    //           .catch(function (e) {
    //             console.log(e.response);
    //           });
    // },
  }









}
</script>
